@let branding = brandingService.branding$ | async;

@if (branding !== null && branding !== undefined) {
    @if (isLearnerMissing) {
        <mm-profile-learner-missing></mm-profile-learner-missing>
    } @else {
        <mm-profile [profileData]="profileData$"
                    [locale]="locale$"
                    [darkMode]="(teamsContextService.teamsContext$ | async)?.app.theme === 'dark'"
                    [shouldTriggerChangeDetectionManually]="true"
                    [profileUpdated]="profileUpdated$"
                    [mainChannel$]="mainChannel$"
                    [allChannels$]="allChannels$"
                    (saveLocal)="saveLocalData($event)"
                    (saveMainChannel)="saveMainChannel($event)"
                    (savePseudonymSettings)="savePseudonymSettings($event)"
                    (generatePseudonym)="generatePseudonym()"
                    (changedMonthlyReport)="changeMonthlyReport($event)"
                    (saveLearningReminderSettings)="saveLearningReminder($event)"></mm-profile>
    }
}
